module.exports = __webpack_public_path__ + "img/icon2.57920a7e.png";